import { LocalizedResponseError } from './LocalizedResponseError';
import { SERVER_RESOURCE_NOT_AVAIL_ERROR_KEY } from './constants';

export class ServerNotAvailableError extends LocalizedResponseError {
    public constructor() {
        super();
        this.statusCode = 0;
        this.isKnownError = true;
        this.errors = [
            {
                i18Key: SERVER_RESOURCE_NOT_AVAIL_ERROR_KEY,
                message: '',
                field: '',
                error: '',
            },
        ];
    }

    public toString() {
        return this.errors[0].i18Key;
    }

    public hasError(): boolean {
        return false;
    }
}
